import { LayoutDashboard, Files, Zap } from 'lucide-react';

interface MobileNavProps {
    activeNav?: string;
    onNavigate?: (nav: string) => void;
    onQuickRender?: () => void;
}

export function MobileNav({ activeNav = 'properties', onNavigate, onQuickRender }: MobileNavProps) {
    return (
        <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border safe-area-inset-bottom">
            <div className="flex items-center justify-around h-16 px-4">
                {/* Properties */}
                <button
                    onClick={() => onNavigate?.('properties')}
                    className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${activeNav === 'properties' ? 'text-primary' : 'text-muted-foreground'
                        }`}
                >
                    <LayoutDashboard className="w-5 h-5" strokeWidth={activeNav === 'properties' ? 2 : 1.5} />
                    <span className="text-[10px] font-medium">Nieruchomości</span>
                </button>

                {/* Quick Render - Center, Prominent */}
                <button
                    onClick={onQuickRender}
                    className="flex flex-col items-center justify-center flex-1 h-full gap-1"
                >
                    <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center -mt-6 shadow-lg shadow-primary/30 border-4 border-background">
                        <Zap className="w-5 h-5 text-primary-foreground" strokeWidth={2} />
                    </div>
                    <span className="text-[10px] font-medium text-primary">Render</span>
                </button>

                {/* All Files */}
                <button
                    onClick={() => onNavigate?.('allphotos')}
                    className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${activeNav === 'allphotos' ? 'text-primary' : 'text-muted-foreground'
                        }`}
                >
                    <Files className="w-5 h-5" strokeWidth={activeNav === 'allphotos' ? 2 : 1.5} />
                    <span className="text-[10px] font-medium">Wszystkie</span>
                </button>
            </div>
        </nav>
    );
}
